import React from 'react';
import Container from '../components/misc/Container';
import LayoutHomepage from '../layout/LayoutHomepage';
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';
import { Link } from 'react-router-dom';
// Import Logo
import { ReactComponent as LogoSentral } from '../assets/logo/sentra-belanja-logo.svg';
const Form = () => {
  return (
    <>
      <DynamicScrollToTop />
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <p className="flex items-center text-font-gray opacity-50">
                  Beranda{' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                <h1 className="text-font-gray">Formulir</h1>
              </div>
              <div className="py-4 rounded bg-white">
                {/* Section Agreement */}
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="ml-auto mr-auto flex items-center p-4">
                    <LogoSentral className="h-12" />
                  </div>
                </div>
                <hr></hr>
                <div className="flex px-auto  border-gray-300"></div>
                <div className="flex px-auto border-gray-300">
                  <div className="flex items-center p-4  w-6/12 mx-auto">
                    <div className="flex flex-col w-full my-6">
                      <div className="flex flex-row border-gray-300 border-b px-4 py-2 items-center">
                        <p className="text-font-gray opacity-50   w-4/12">
                          Nama
                        </p>
                        <p className="text-font-gray opacity-50">:</p>
                        <input
                          type="text"
                          className="focus:outline-none form-input  ml-4 w-full text-font-gray bg-white-200 border-none"
                          placeholder="Isi Nama anda"
                        />
                        <hr />
                      </div>
                      <div className="flex flex-row border-gray-300 border-b px-4 py-2 items-center">
                        <p className="text-font-gray opacity-50  w-4/12">
                          Perusahaan
                        </p>
                        <p className="text-font-gray opacity-50">:</p>
                        <input
                          type="text"
                          className="focus:outline-none form-input  ml-2 w-full text-font-gray bg-white-200 border-none"
                          placeholder="Isi Nama  perusahaan anda"
                        />
                        <hr />
                      </div>
                      <div className="flex flex-row border-gray-300 border-b px-4 py-2 items-center">
                        <p className="text-font-gray opacity-50  w-4/12">
                          Telepon
                        </p>
                        <p className="text-font-gray opacity-50">:</p>
                        <input
                          type="text"
                          className="focus:outline-none form-input  ml-2 w-full text-font-gray bg-white-200 border-none"
                          placeholder="Isi no telp anda"
                        />
                        <hr />
                      </div>
                      <div className="flex flex-row border-gray-300 border-b px-4 py-2 items-center">
                        <p className="text-font-gray opacity-50  w-4/12">
                          Alamat
                        </p>
                        <p className="text-font-gray opacity-50">:</p>
                        <input
                          type="text"
                          className="focus:outline-none form-input  ml-2 w-full text-font-gray bg-white-200 border-none"
                          placeholder="Isi alamat anda"
                        />
                        <hr />
                      </div>
                      <Link
                        to="/homepage"
                        className="rounded-lg bg-basic-orange mx-auto text-white mt-8  py-2 px-8 font-bold text-lg"
                      >
                        {' '}
                        Kirim
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Form;
